import { useEffect, useState } from "react";

import { getAvailableMenuItems } from "@/api/requests/getAvailableMenuItems";
import { MenuItem } from "@/custom-types/MenuItem";
import { Strain } from "@/custom-types/Strain";
import { useSelector } from "@/redux/hooks";
import { getCoordinates } from "@/redux/selectors/location";

type StrainsWithAvailability = {
  name: string;
  hasMenuItems: boolean;
};

type Props = {
  strainsWithMenuItemAvailability: StrainsWithAvailability[];
};

const useStrainsWithMenuItemAvailability = (strains: Strain[]): Props => {
  const [strainsWithMenuItemAvailability, setStrainsWithMenuItemAvailability] =
    useState<StrainsWithAvailability[]>([]);

  const coordinates = useSelector(getCoordinates);

  useEffect(() => {
    if (strains?.length) {
      const strainNames = strains.map((strain) => strain.name);

      getAvailableMenuItems(coordinates, strainNames).then((menuItems) => {
        const strainsWithAvailability = strains?.map((strain) => {
          const hasMenuItems = !!menuItems.filter(
            (menuItem: MenuItem) => menuItem.name === strain.name,
          )?.[0]?.menuItemCategories?.length;

          return { hasMenuItems, name: strain.name };
        });

        setStrainsWithMenuItemAvailability(strainsWithAvailability);
      });
    }
  }, [JSON.stringify(strains)]);

  return { strainsWithMenuItemAvailability };
};

export default useStrainsWithMenuItemAvailability;
